import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaUser,
  FaBirthdayCake,
  FaMapMarkerAlt,
  FaUniversity,
  FaEnvelope,
  FaPhone,
  FaCalendarPlus,
  FaVenusMars,
  FaStore,
  FaSave,
} from "react-icons/fa";
import PageCreateHeader from "../../components/PageCreateHeader";

const CreateKaryawan = () => {
  const navigate = useNavigate();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    fullname: "",
    tempat_lahir: "",
    tanggal_lahir: "",
    alamat: "",
    gender: "",
    pendidikan: "",
    no_hp: "",
    email: "",
    join_date: "",
    penempatan: "",
  });

  const [errors, setErrors] = useState({});
  const [outlets, setOutlets] = useState([]);

  const token = localStorage.getItem("token") || sessionStorage.getItem("token");

  // Fetch Outlets
  useEffect(() => {
    const fetchOutlets = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/v1/outlet`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        setOutlets(response.data.data);
      } catch (error) {
        console.error("Error mengambil outlet:", error);
      }
    };

    fetchOutlets();
  }, [token]);

  // Handle Input Change + Live Validation
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));

    if (!value) {
      setErrors((prev) => ({ ...prev, [name]: `${name} wajib diisi` }));
    } else {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }

    if (name === "email") {
      const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      setErrors((prev) => ({ ...prev, email: valid ? "" : "Email tidak valid" }));
    }

    if (name === "no_hp") {
      const valid = /^[0-9+]{8,15}$/.test(value);
      setErrors((prev) => ({
        ...prev,
        no_hp: valid ? "" : "Nomor HP tidak valid",
      }));
    }
  };

  // Validate All Before Submit
  const validateForm = () => {
    let newErrors = {};

    Object.keys(formData).forEach((key) => {
      if (!formData[key] && key !== "penempatan") {
        newErrors[key] = `${key} wajib diisi`;
      }
    });

    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Email tidak valid";
    }
    if (formData.no_hp && !/^[0-9+]{8,15}$/.test(formData.no_hp)) {
      newErrors.no_hp = "Nomor HP tidak valid";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Submit Handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      setLoading(true);

      const payload = {
        ...formData,
        penempatan: parseInt(formData.penempatan, 10),
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/employee`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        setShowSuccessModal(true);

        setTimeout(() => {
          navigate("/enterprise/karyawan");
        }, 1500);
      }
    } catch (error) {
      alert("Gagal menambahkan karyawan.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col space-y-6 w-full min-w-0">
      <PageCreateHeader
        icon={FaUser}
        title="Buat Karyawan"
        description="Tambah data karyawan dan penempatan outlet"
        breadcrumbs={[
          { label: "Enterprise", to: "/" },
          { label: "Karyawan", to: "/enterprise/karyawan" },
          { label: "Buat Karyawan" },
        ]}
      />

      <div className="p-8 bg-white rounded-3xl shadow-xl border border-gray-100 w-full">
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 gap-6">

          {[
            { label: "Nama", name: "fullname", type: "text", icon: <FaUser /> },
            { label: "Tempat Lahir", name: "tempat_lahir", type: "text", icon: <FaMapMarkerAlt /> },
            { label: "Alamat", name: "alamat", type: "text", icon: <FaMapMarkerAlt /> },
            { label: "Tanggal Lahir", name: "tanggal_lahir", type: "date", icon: <FaBirthdayCake /> },
            { label: "Pendidikan", name: "pendidikan", type: "text", icon: <FaUniversity /> },
            { label: "Email", name: "email", type: "email", icon: <FaEnvelope /> },
            { label: "No. HP", name: "no_hp", type: "text", icon: <FaPhone /> },
            { label: "Join Date", name: "join_date", type: "date", icon: <FaCalendarPlus /> },
          ].map(({ label, name, type, icon }) => (
            <div key={name}>
              <label className="block mb-2 text-gray-700 font-medium flex items-center gap-2">
                {icon} {label}
              </label>

              <input
                type={type}
                name={name}
                value={formData[name]}
                onChange={handleChange}
                className={`w-full rounded-xl px-4 py-3 border shadow-sm bg-gray-50
                focus:ring-2 focus:ring-green-400 transition
                ${errors[name] ? "border-red-400" : "border-gray-300"}
              `}
              />

              {errors[name] && (
                <p className="text-red-600 text-sm mt-1">{errors[name]}</p>
              )}
            </div>
          ))}

          {/* Gender */}
          <div>
            <label className="block mb-2 text-gray-700 font-medium flex items-center gap-2">
              <FaVenusMars /> Gender
            </label>

            <select
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              className={`w-full rounded-xl px-4 py-3 border shadow-sm bg-gray-50
                focus:ring-2 focus:ring-green-400 transition
                ${errors.gender ? "border-red-400" : "border-gray-300"}
              `}
            >
              <option value="">Pilih Gender</option>
              <option value="male">Laki-laki</option>
              <option value="female">Perempuan</option>
            </select>

            {errors.gender && (
              <p className="text-red-600 text-sm mt-1">{errors.gender}</p>
            )}
          </div>

          {/* Outlet */}
          <div>
            <label className="block mb-2 text-gray-700 font-medium flex items-center gap-2">
              <FaStore /> Outlet (Penempatan)
            </label>

            <select
              name="penempatan"
              value={formData.penempatan}
              onChange={handleChange}
              className="w-full rounded-xl px-4 py-3 border border-gray-300 shadow-sm bg-gray-50 focus:ring-2 focus:ring-green-400 transition"
            >
              <option value="">Pilih Outlet</option>
              {outlets.map((outlet) => (
                <option key={outlet.id} value={outlet.id}>
                  {outlet.name}
                </option>
              ))}
            </select>
          </div>

        </div>

        {/* Submit Button */}
        <div className="mt-10">
          <button
            type="submit"
            disabled={loading}
            className="bg-green-600 hover:bg-green-700 text-white font-semibold px-8 py-3 rounded-xl shadow-lg flex items-center gap-2 transition disabled:bg-gray-400"
          >
            <FaSave /> {loading ? "Menyimpan..." : "Simpan"}
          </button>
        </div>
      </form>

      {/* SUCCESS MODAL */}
      {showSuccessModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center z-50 transition">
          <div className="bg-white p-8 rounded-2xl shadow-2xl w-96 text-center animate-scaleFade">
            <h2 className="text-2xl font-bold text-green-600 mb-2">Berhasil!</h2>
            <p className="text-gray-700">Karyawan berhasil ditambahkan.</p>
          </div>
        </div>
      )}

      </div>
    </div>
  );
};

export default CreateKaryawan;
